import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=3d87a62c&scoped=true"
import script from "./VersionUpdate.vue?vue&type=script&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=3d87a62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87a62c",
  null
  
)

export default component.exports